/* eslint-disable  */
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Badge, IconButton } from "@material-ui/core";
import { MessageSharp, NotificationImportant } from "@material-ui/icons";
import {
  Menu,
  X,
  Home,
  Layers,
  DollarSign,
  FileText,
  BookOpen,
  CheckCircle,
  Clock,
  CreditCard,
  AlertTriangle,
  FileEdit,
  XCircle,
  ClipboardList,
  Calculator,
  BarChart2,
  LogOut,
  ChevronLeft,
  ChevronDown,
  ChevronRight,
  Calendar,
  ScrollText,
  FileCheck2,
  Send,
  BadgeCheck,
} from "lucide-react";

// Redux Actions
import { GetUserProfile, SignOut } from "../services/Actions/authActions";
import { GetLoanOfficersMessagesUnread } from "../services/Actions/MessagesAction";
import { GetNotificationsByLoanOfficers } from "../services/Actions/notificationAction";
import { GetTotalLoanStats } from "../services/Actions/dataAction";
import { GhanaMoneyDisplay } from "../helpers/helper";
import { RolesContants } from "../contants";
import { bindActionCreators } from "redux";
import { dataActionCreators } from "../services/Actions";
import ThemeToggle from "../Components/ThemeToggle";

function RenderLoanPage({ children, title, page = 1 }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openSections, setOpenSections] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const message = useSelector((state) => state?.message);
  const data = useSelector((state) => state?.data);
  const notificationsObj = useSelector((state) => state?.notification);
  const { notifications } = notificationsObj;
  const { user } = auth;
  const { totalMonthlyLoansBooked, isLoading } = data;

  const { GetTotalMonthlyBooked } = bindActionCreators(
    dataActionCreators,
    dispatch
  );

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  const now = new Date();
  const [selectedMonth, setSelectedMonth] = useState(now.getMonth() + 1); // 1-12
  const [selectedYear, setSelectedYear] = useState(now.getFullYear());
  const [showMonthPicker, setShowMonthPicker] = useState(false);

  const isCurrentOrFuture = () => {
    const curY = now.getFullYear();
    const curM = now.getMonth() + 1;
    return selectedYear > curY || (selectedYear === curY && selectedMonth >= curM);
  };

  const handlePrevMonth = () => {
    if (selectedMonth === 1) {
      setSelectedMonth(12);
      setSelectedYear((y) => y - 1);
    } else {
      setSelectedMonth((m) => m - 1);
    }
  };

  const handleNextMonth = () => {
    if (isCurrentOrFuture()) return;
    if (selectedMonth === 12) {
      setSelectedMonth(1);
      setSelectedYear((y) => y + 1);
    } else {
      setSelectedMonth((m) => m + 1);
    }
  };

  useEffect(() => {
    dispatch(GetUserProfile());
    dispatch(GetTotalLoanStats());
    dispatch(GetLoanOfficersMessagesUnread());
    dispatch(GetNotificationsByLoanOfficers());
  }, [dispatch]);

  useEffect(() => {
    GetTotalMonthlyBooked(selectedMonth, selectedYear);
  }, [selectedMonth, selectedYear]);

  const handleLogout = () => {
    dispatch(SignOut());
    setTimeout(() => window.location.reload(false), 500);
  };

  const navItems = [
    { label: "Dashboard", icon: <Home size={18} />, path: "/loans/home" },
    {
      label: "Fund Deduction",
      icon: <Layers size={18} />,
      path: "/loans/fund-deduction",
    },
    {
      label: "Loans Deduction",
      icon: <DollarSign size={18} />,
      path: "/loans/loans-deduction",
    },
    {
      label: "Loan Applications",
      icon: <FileText size={18} />,
      path: "/loans/application",
    },
    {
      label: "Booked Loans",
      icon: <BookOpen size={18} />,
      path: "/loans/booked",
    },
    {
      label: "Authorized Loans",
      icon: <CheckCircle size={18} />,
      path: "/loans/authorized",
    },
    {
      label: "Initiated Loans",
      icon: <Clock size={18} />,
      path: "/loans/initiated",
    },
    {
      label: "Loans Paid",
      icon: <CreditCard size={18} />,
      path: "/loans/paid",
    },
    {
      label: "Incomplete Loans",
      icon: <AlertTriangle size={18} />,
      path: "/loans/incomplete-loan",
    },
    {
      label: "Updated Loan Forms",
      icon: <FileEdit size={18} />,
      path: "/loans/updated-loan",
    },
    {
      label: "Rejected Loans",
      icon: <XCircle size={18} />,
      path: "/loans/rejected",
    },
    {
      label: "Loan Status",
      icon: <ClipboardList size={18} />,
      path: "/loans/status",
    },
    {
      label: "Loan Calculator",
      icon: <Calculator size={18} />,
      path: "/loans/calculator",
    },
    // The three settlement stages as one collapsible group, matching the
    // support sidebar: pending requests to quote → quotes sent to the member
    // (mark as paid from the detail screen) → already settled.
    {
      label: "Settlements",
      icon: <ScrollText size={18} />,
      children: [
        { label: "Requests", icon: <ScrollText size={15} />, path: "/loans/settlement" },
        { label: "Sent", icon: <Send size={15} />, path: "/loans/sent-settlements" },
        { label: "Paid", icon: <BadgeCheck size={15} />, path: "/loans/paid-settlements" },
      ],
    },
    {
      label: "Clearance",
      icon: <FileCheck2 size={18} />,
      path: "/loans/clearance",
      // Only these roles see this item in the side panel. Items without a
      // `roles` key stay visible to everyone.
      roles: [RolesContants.LOAN_OFFICER_HEAD],
    },
    {
      label: "Report",
      icon: <BarChart2 size={18} />,
      path: "/loans/loan-report",
    },
  ];

  // Hide role-restricted items from users who don't hold one of the allowed
  // roles. Items with no `roles` key are visible to everyone.
  const userRoles = auth?.role || [];
  const visibleNavItems = navItems.filter(
    (item) => !item.roles || item.roles.some((r) => userRoles.includes(r))
  );

  const isLinkActive = (path) => {
    const [itemPath, itemQuery] = path.split("?");
    return (
      location.pathname === itemPath &&
      (!itemQuery || location.search === `?${itemQuery}`)
    );
  };
  const isChildActive = (item) => item.children?.some((c) => isLinkActive(c.path));

  // Expand whichever group owns the current route, so landing on a child link
  // directly doesn't leave it collapsed.
  useEffect(() => {
    const active = navItems.find((item) => isChildActive(item));
    if (active) {
      setOpenSections((prev) =>
        prev.includes(active.label) ? prev : [...prev, active.label]
      );
    }
  }, [location.pathname, location.search]);

  const toggleSection = (label) =>
    setOpenSections((prev) =>
      prev.includes(label) ? prev.filter((s) => s !== label) : [...prev, label]
    );

  const NavLink = ({ item }) => {
    const isActive = isLinkActive(item.path);
    return (
      <button
        onClick={() => {
          history.push(item.path);
          setIsMobileMenuOpen(false);
        }}
        title={isCollapsed ? item.label : ""}
        className={`w-full flex items-center ${isCollapsed ? "justify-center" : "gap-3"} px-3 py-3 rounded-md transition-all duration-200 group ${isActive
          ? "bg-indigo-600 text-white shadow-md shadow-indigo-200 dark:shadow-indigo-900"
          : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-gray-800 hover:text-indigo-600 dark:hover:text-indigo-400"
          }`}
      >
        <span
          className={`flex-shrink-0 ${isActive
            ? "text-white"
            : "text-slate-400 dark:text-slate-500 group-hover:text-indigo-600 dark:group-hover:text-indigo-400"
            }`}
        >
          {item.icon}
        </span>
        {!isCollapsed && <span className="text-sm font-semibold">{item.label}</span>}
      </button>
    );
  };

  // Collapsible group. When the sidebar is collapsed there's no room for the
  // child list, so the icon navigates to the first child instead of toggling
  // an invisible section.
  const NavSection = ({ item }) => {
    const sectionOpen = openSections.includes(item.label);
    const hasActive = isChildActive(item);
    return (
      <div>
        <button
          onClick={() => {
            if (isCollapsed) {
              history.push(item.children[0].path);
              setIsMobileMenuOpen(false);
            } else {
              toggleSection(item.label);
            }
          }}
          title={isCollapsed ? item.label : ""}
          className={`w-full flex items-center ${isCollapsed ? "justify-center" : "justify-between"} px-3 py-3 rounded-md transition-all duration-200 group ${hasActive
            ? "text-indigo-600 dark:text-indigo-400"
            : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-gray-800 hover:text-indigo-600 dark:hover:text-indigo-400"
            }`}
        >
          <div className={`flex items-center ${isCollapsed ? "" : "gap-3"}`}>
            <span
              className={`flex-shrink-0 ${hasActive
                ? "text-indigo-600 dark:text-indigo-400"
                : "text-slate-400 dark:text-slate-500 group-hover:text-indigo-600 dark:group-hover:text-indigo-400"
                }`}
            >
              {item.icon}
            </span>
            {!isCollapsed && <span className="text-sm font-semibold">{item.label}</span>}
          </div>
          {!isCollapsed && (
            <ChevronDown
              size={14}
              className={`transition-transform ${sectionOpen ? "rotate-180" : ""} text-slate-400`}
            />
          )}
        </button>

        {!isCollapsed && sectionOpen && (
          <div className="ml-4 pl-3 border-l-2 border-slate-100 dark:border-gray-700 space-y-0.5 mt-0.5 mb-1">
            {item.children.map((child) => {
              const isActive = isLinkActive(child.path);
              return (
                <button
                  key={child.path}
                  onClick={() => {
                    history.push(child.path);
                    setIsMobileMenuOpen(false);
                  }}
                  className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-md transition-all duration-200 group ${isActive
                    ? "bg-indigo-600 text-white shadow-md shadow-indigo-200 dark:shadow-indigo-900"
                    : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-gray-800 hover:text-indigo-600 dark:hover:text-indigo-400"
                    }`}
                >
                  <span
                    className={`flex-shrink-0 ${isActive
                      ? "text-white"
                      : "text-slate-400 dark:text-slate-500 group-hover:text-indigo-600 dark:group-hover:text-indigo-400"
                      }`}
                  >
                    {child.icon}
                  </span>
                  <span className="text-sm font-semibold">{child.label}</span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  const sidebarWidth = isCollapsed ? "w-[68px]" : "w-72";
  const mainPadding = isCollapsed ? "lg:pl-[68px]" : "lg:pl-72";

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex py-1 transition-colors duration-300">
      {/* SIDEBAR */}
      <aside
        className={`
        fixed inset-y-0 left-0 z-50 ${sidebarWidth} bg-white dark:bg-gray-900 border-r border-slate-200 dark:border-gray-700 transform transition-all duration-300 ease-in-out
        lg:translate-x-0 ${isMobileMenuOpen ? "translate-x-0 !w-72" : "-translate-x-full"}
      `}
      >
        <div className="h-full flex flex-col">
          {/* Logo Section */}
          <div className="p-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 bg-indigo-600 rounded-lg flex items-center justify-center text-white font-bold flex-shrink-0">
                L
              </div>
              {!isCollapsed && (
                <span className="text-md font-bold text-slate-800 dark:text-slate-100">
                  Loans Admin
                </span>
              )}
            </div>
            <button
              onClick={() => setIsCollapsed(!isCollapsed)}
              className="hidden lg:flex p-1.5 rounded-lg border border-slate-200 dark:border-gray-600 text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-gray-800 transition-colors"
            >
              <ChevronLeft
                size={16}
                style={{
                  transform: isCollapsed ? "rotate(180deg)" : "none",
                  transition: "transform 0.3s",
                }}
              />
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="lg:hidden p-2 text-slate-500 dark:text-slate-400"
            >
              <X size={20} />
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="flex-1 px-2 py-1 overflow-y-auto space-y-1 custom-scrollbar">
            {visibleNavItems.map((item) =>
              item.children ? (
                <NavSection key={item.label} item={item} />
              ) : (
                <NavLink key={item.path} item={item} />
              )
            )}
          </nav>

          {/* User Profile Footer */}
          <div className="p-2 border-t border-slate-100 dark:border-gray-700 bg-slate-50/50 dark:bg-gray-800/50">
            {!isCollapsed ? (
              <>
                <div className="flex items-center gap-2 mb-2 px-2">
                  <img
                    className="w-8 h-8 rounded-full border-2 border-white dark:border-gray-600 shadow-sm flex-shrink-0"
                    src={user?.profile_image || "/images/dev/avatar1.png"}
                    alt="User"
                  />
                  <div className="overflow-hidden">
                    <p className="text-xs font-bold text-slate-800 dark:text-slate-100 truncate">
                      {user?.name || "Loan Officer"}
                    </p>
                    <p className="text-xs text-slate-500 dark:text-slate-400 truncate">Loan Officer</p>
                  </div>
                </div>
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center justify-center gap-2 px-2 py-2 bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-600 text-rose-600 rounded-xl hover:bg-rose-50 dark:hover:bg-gray-700 hover:border-rose-100 dark:hover:border-gray-500 transition-colors font-semibold text-sm shadow-sm"
                >
                  <LogOut size={16} />
                  Logout
                </button>
              </>
            ) : (
              <button
                onClick={handleLogout}
                title="Logout"
                className="w-full flex items-center justify-center py-2 text-rose-600 hover:bg-rose-50 dark:hover:bg-gray-700 rounded-xl transition-colors"
              >
                <LogOut size={18} />
              </button>
            )}
          </div>
        </div>
      </aside>

      {/* MAIN CONTENT AREA */}
      <main className={`flex-1 flex flex-col min-w-0 ${mainPadding} transition-all duration-300`}>
        {/* TOP BAR */}
        <header className="sticky top-0 z-40 bg-white/60 dark:bg-gray-900/60 backdrop-blur-md border-b border-slate-200 dark:border-gray-700 px-4 sm:px-3 lg:px-4 py-2 transition-colors duration-300">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsMobileMenuOpen(true)}
                className="lg:hidden p-2 rounded-lg bg-slate-100 dark:bg-gray-800 text-slate-600 dark:text-slate-300"
              >
                <Menu size={18} />
              </button>
              <h1 className="text-md font-bold text-slate-800 dark:text-slate-100 hidden sm:block">
                {title || "Dashboard"}
              </h1>
            </div>

            <div className="flex items-center gap-2 sm:gap-4">
              <ThemeToggle />

              <IconButton onClick={() => history.push("/loans/messages")}>
                <Badge
                  badgeContent={message?.loanMessagesUnread}
                  color="secondary"
                >
                  <MessageSharp className="text-slate-500 dark:text-slate-400" />
                </Badge>
              </IconButton>

              <IconButton onClick={() => history.push("/loans/notifications")}>
                <Badge
                  badgeContent={notifications?.length}
                  color="secondary"
                >
                  <NotificationImportant className="text-slate-500 dark:text-slate-400" size={16} />
                </Badge>
              </IconButton>

              <div className="h-8 w-px bg-slate-200 dark:bg-gray-600 mx-1 hidden sm:block"></div>

              <img
                onClick={() => history.push("/loans/profile")}
                className="w-7 h-7 rounded-full cursor-pointer ring-2 ring-transparent hover:ring-indigo-500 transition-all shadow-sm"
                src={user?.profile_image || "/images/dev/avatar1.png"}
                alt="Avatar"
              />
            </div>
          </div>
        </header>

        {/* PAGE CONTENT */}
        <div className="p-4 sm:p-6 lg:p-8">
          <div className="mb-6">
            <h2 className="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
              {title}
            </h2>
            {title && (
              <div className="h-1 w-12 bg-indigo-600 rounded-full mt-2"></div>
            )}
          </div>
          <div className="animate-in fade-in duration-500">{children}</div>
        </div>

        {/* FOOTER - Monthly Loan Summary */}
        <div className="mt-auto sticky bottom-0 bg-gradient-to-r from-blue-700 to-indigo-700 px-4 py-2.5 shadow-[0_-4px_16px_rgba(0,0,0,0.15)]">
          <div className="flex items-center justify-between gap-3 flex-wrap">
            {/* Label */}
            <div className="flex items-center gap-1.5">
              <Calendar size={13} className="text-blue-200" />
              <span className="text-blue-100 text-sm font-semibold uppercase tracking-wider">Monthly Bookings</span>
            </div>

            {/* Month Navigator */}
            <div className="flex items-center gap-1">
              <button
                onClick={handlePrevMonth}
                className="w-6 h-6 flex items-center justify-center rounded-md text-white/70 hover:text-white hover:bg-white/15 transition-all"
                title="Previous month"
              >
                <ChevronLeft size={14} />
              </button>
              <button
                onClick={() => setShowMonthPicker((v) => !v)}
                className="px-2.5 py-1 bg-white/15 hover:bg-white/25 rounded-lg text-white text-sm font-bold min-w-[130px] text-center transition-all"
              >
                {monthNames[selectedMonth - 1]}, {selectedYear}
                {selectedYear === now.getFullYear() && selectedMonth === now.getMonth() + 1 && (
                  <span className="ml-1.5 text-[10px] bg-white/30 text-white rounded-full px-1.5 py-0.5">Current</span>
                )}
              </button>
              <button
                onClick={handleNextMonth}
                disabled={isCurrentOrFuture()}
                className="w-6 h-6 flex items-center justify-center rounded-md text-white/70 hover:text-white hover:bg-white/15 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                title="Next month"
              >
                <ChevronRight size={14} />
              </button>
            </div>

            {/* Amount */}
            <div className="flex items-center gap-1.5">
              <span className="text-blue-200 text-sm">Total:</span>
              <strong className="text-white text-sm font-black tabular-nums">
                <GhanaMoneyDisplay amount={totalMonthlyLoansBooked} />
              </strong>
            </div>
          </div>

          {/* Inline Month Picker */}
          {showMonthPicker && (
            <div className="mt-2 pt-2 border-t border-white/20">
              <div className="grid grid-cols-4 gap-1 mb-2">
                {monthNames.map((m, i) => {
                  const mon = i + 1;
                  const isFuture = selectedYear > now.getFullYear() || (selectedYear === now.getFullYear() && mon > now.getMonth() + 1);
                  const isSelected = selectedMonth === mon;
                  return (
                    <button
                      key={m}
                      disabled={isFuture}
                      onClick={() => { setSelectedMonth(mon); setShowMonthPicker(false); }}
                      className={`text-sm py-1 rounded-md font-semibold transition-all ${isSelected ? "bg-white text-indigo-700" : "text-white/80 hover:bg-white/20"} disabled:opacity-30 disabled:cursor-not-allowed`}
                    >
                      {m.slice(0, 3)}
                    </button>
                  );
                })}
              </div>
              <div className="flex items-center justify-center gap-2">
                <button
                  onClick={() => setSelectedYear((y) => y - 1)}
                  className="w-6 h-6 flex items-center justify-center rounded text-white/70 hover:text-white hover:bg-white/20 transition-all"
                >
                  <ChevronLeft size={13} />
                </button>
                <span className="text-white text-xs font-bold">{selectedYear}</span>
                <button
                  onClick={() => { if (selectedYear < now.getFullYear()) setSelectedYear((y) => y + 1); }}
                  disabled={selectedYear >= now.getFullYear()}
                  className="w-6 h-6 flex items-center justify-center rounded text-white/70 hover:text-white hover:bg-white/20 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                >
                  <ChevronRight size={13} />
                </button>
              </div>
            </div>
          )}
        </div>
      </main>

      {/* MOBILE OVERLAY */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-slate-900/40 dark:bg-black/50 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </div>
  );
}

export default RenderLoanPage;
